/**
@ngdoc controller
@name I18nCtrl

@description
This controller is used in /uiMessage/i18n/

*/
(function() {
    'use strict';
    var I18nCtrl = function($scope, $compile, caseService, $http) {
        I18nCtrl.$inject = ['$scope', '$compile'];
        var DEBUG = false;

        if(DEBUG) {
            console.log('I18nCtrl running');
        }

        //Generates a summary i18n code value in camelCase format
		var fnGenerateSummary = function(){
			if(DEBUG) {
                console.log('I18nCtrl fnGenerateSummary()');
            }
        	$scope.formModel.summary = caseService.camelCaseSentance($scope.formModel.defaultMessage,true);
    	};

        //replaces empty values with undefined
    	var fnUndefined = function(value){
    		if(value=='') {
                return 'undefined';
            }
    		return value;
    	};

        //Generates a code value by using the format messageOwner.summary.messageType
    	var fnGenerateCode = function(){
    		if(DEBUG) {
                console.log('I18nCtrl fnGenerateCode()');
            }
        	$scope.formModel.code = fnUndefined($scope.formModel.messageOwner) +'.'+
				fnUndefined($scope.formModel.summary) +'.'+
				fnUndefined($scope.formModel.messageType);
    	};

        //Identify if the user is hand tailoring a value - used for summary and code
    	var fnHandTailored = function(fieldNameTouched, fieldName, isHandTailored){
    		//if you're touching the "hand tailored" field, you may be hand tailoring it...
    		if(fieldNameTouched==fieldName){
    			//If the "hand tailored" field is not empty, you are hand tailoring it.
    			//If the "hand tailored" field is empty, you wish to re-instate auto value.
    			isHandTailored = ($scope.formModel[fieldName]!='');
    		}
    		if(DEBUG) {
                console.log('I18nCtrl fnHandTailored()', fieldName, isHandTailored);
            }
    		return isHandTailored;
    	};

        //inital values
    	var handTailoredSummary = false;
    	var handTailoredCode = false;

        //fired by ng-change on mutiple fields - generates a summary and code based upon rules
        $scope.fnEntriesChanged = function(_this){
        	//console.log('woo');
        	var fieldNameTouched = _this.formField.$name;

        	if(DEBUG) {
                console.log('-----fnEntriesChanged()', fieldNameTouched);
        	    console.log('handTailoredSummary', handTailoredSummary);
        	    console.log('handTailoredCode', handTailoredCode);
            }

			handTailoredSummary = fnHandTailored(fieldNameTouched, 'summary', handTailoredSummary)
			handTailoredCode = fnHandTailored(fieldNameTouched, 'code', handTailoredCode)

			if( !handTailoredSummary ){
				fnGenerateSummary();
			}
			if( !handTailoredCode ){
				fnGenerateCode();
			}
            return;
        };

        //Section toggling CONFIG SET UP
        var SECTION_ON_LOAD = 'NEW';//'EXISTING';

        //Section toggling Initial SET UP
        $scope.showNewSection      = (SECTION_ON_LOAD=='NEW');
        $scope.showExistingSection = (SECTION_ON_LOAD=='EXISTING');

        //toggle the sections
        $scope.fnToggleSection = function(){
            $scope.showNewSection      = !$scope.showNewSection;
            $scope.showExistingSection = !$scope.showExistingSection;
            return;
        };

        //when a i18n selection has been made sets the Lookup being changed
        $scope.fnSetLookupBeingChanged = function(findByCode){
            if(DEBUG) {
                console.log('fnSetLookupBeingChanged(findByCode)', findByCode);
            }
            //short hand
            var formModelRef =  $scope.formModel;
            var updateRef    = formModelRef.update;
            var findByRef    = findByCode ? formModelRef.findByCode : formModelRef.findByDefault;
            if(findByRef){
                //Set the update fields to what was found via search
                updateRef['code']         = findByRef['code'];
                updateRef['default']      = findByRef['default'];
                updateRef['i18nLocaleId'] = findByRef['id'];
            } else {
                //if $scope.formModel.findBy[Code/Default] is undefined we have no search result!
                updateRef['code']         = '';
                updateRef['default']      = '';
                updateRef['i18nLocaleId'] = '';
            }
            return;
        };

        $scope.fnFindExistingByDefault = function(url){
            //WORK IN PROGRESS - Will collect existing i18n using default
            if(DEBUG) console.log('fnFindExistingByDefault(url)', url );
            $http.get(url).then(
                function(response){//success
                    console.log('success');
                },
                function(response){//error
                    console.log('error');
                }
            );
        };

    };
    I18nCtrl.$inject = ['$scope', '$compile', 'caseService', '$http'];
    angular.module('app').controller('I18nCtrl', I18nCtrl);
}());